import React from 'react';
import { companyInfo, footerContent } from '../data/mock';
import { MapPin, Mail, Building2 } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <span className="text-slate-800 font-bold text-lg">P</span>
              </div>
              <span className="font-semibold text-xl">pakuskapis.lv<sup className="text-xs">™</sup></span>
            </div>
            <p className="text-slate-400 mb-6 max-w-md">
              pakuskapis.lv™ risinājumi pašvaldībām, bankām, 
              uzņēmumiem un sabiedriskām iestādēm Latvijā.
            </p>
            <div className="flex flex-wrap gap-3">
              {footerContent.taglines.map((tagline, index) => (
                <span
                  key={index}
                  className="bg-slate-800 px-3 py-1 rounded-full text-sm text-slate-300"
                >
                  {tagline}
                </span>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Kontakti</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Building2 className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-300">{companyInfo.company}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-300">
                  {companyInfo.address}<br />
                  {companyInfo.postalCode} {companyInfo.city}<br />
                  {companyInfo.country}
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-slate-400 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Keywords for SEO */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Pakalpojumi</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Pakuskapji pašvaldībām</li>
              <li>Bibliotēku pakuskapji</li>
              <li>Sūtījumu skapji</li>
              <li>Dokumentu pakuskapji</li>
              <li>Pakomāti uzņēmumiem</li>
              <li>Āra pakuskapji</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} {companyInfo.company}. Visas tiesības aizsargātas.
            </p>
            <p className="text-slate-500 text-sm">
              Darbojamies Latvijā kopš {companyInfo.operatingSince}. gada
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
